import React, { useContext, useEffect, useState, useCallback } from "react";

// Highcharts
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsItemSeries from "highcharts/modules/item-series";
import HighchartsData from "highcharts/modules/data";
import HighchartsAccessibility from "highcharts/modules/accessibility";

import { FilterContext } from "../../context/FilterContext";

import { GetDataContext } from "../../context/GetDataContext";
import SeatsHandling from "../../utils/seatsHandling";

//Components
import PollingCompanies from "../Menus/polling-companies";

// Modules
HighchartsItemSeries(Highcharts);
HighchartsData(Highcharts);
HighchartsAccessibility(Highcharts);

const getChartHeight = () => {
  const windowWidth = window.innerWidth;

  if (windowWidth < 372) {
    return (9 / 16) * 100 + "%";    
  } else if (windowWidth < 433) {
    return "73%";
  } else if (windowWidth < 768) {
    return (9 / 16) * 100 + "%";
  } else if (windowWidth < 1024) {
    return 325;
  } else {
    return 380;
  }
};

const Parliament = () => {
  const [chartHeight, setChartHeight] = useState(getChartHeight);
  //Incoming Data
  const { dataHandlingDone } = useContext(GetDataContext);
  //Filtering
  const { filter } = useContext(FilterContext);
  //Parliament Diagrams Handling Init
  // let dataConfigs = [];
  const [dataConfigs, setDataConfigs] = useState([]);
  let diagramSize = "170%";

  if (window.innerWidth <= 360) {
    diagramSize = "240%";
  }

  useEffect(() => {
    dataHandlingDone && setDataConfigs(SeatsHandling());
  }, [dataHandlingDone, filter]);

  const handleResize = useCallback(() => {
    setChartHeight(getChartHeight());
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  // const parliamentChart_Simple = {
  //     chart: {
  //         type: 'item',
  //         height: (9 / 16 * 100) + '%', // 16:9 ratio
  //     },
  //     credits: {
  //         enabled: false
  //     },
  //     title: {
  //         text: '' // leave empty to hide title
  //     },
  //     legend: {
  //         enabled: false,
  //         labelFormat: '{name} <span style="opacity: 0.4">{y}</span>'
  //     },
  //     series: [
  //         {
  //             name: 'Έδρες',
  //             keys: ['name', 'y', 'color', 'label'],
  //             data: dataConfigs[0],
  //             dataLabels: {
  //                 enabled: false,
  //                 format: '{point.label}'
  //             },
  //             // Circular options
  //             center: ['50%', '88%'],
  //             size: diagramSize,
  //             startAngle: -100,
  //             endAngle: 100
  //         }
  //     ],
  // }

  const parliamentChart_Reinforced = {
    chart: {
      type: "item",
      height: chartHeight,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "", // leave empty to hide title
    },
    legend: {
      enabled: false,
      labelFormat: '{name} <span style="opacity: 0.4">{y}</span>',
    },

    series: [
      {
        name: "Έδρες",
        keys: ["name", "y", "color", "label"],
        data: dataConfigs[1],
        dataLabels: {
          enabled: false,
          format: "{point.label}",
        },
        legend: {
          enabled: false,
        },
        // Circular options
        center: ["50%", "88%"],
        size: diagramSize,
        startAngle: -100,
        endAngle: 100,
      },
    ],
  };

  return (
    <section className={"container parliament-container"}>
      <div className={"container_header"}>
        <h2 className={"section__title"}>{"KΑΤΑΝΟΜΗ ΕΔΡΩΝ*"}</h2>
        <PollingCompanies />
      </div>
      <div className={"parliament-charts"}>
        {/* <div className={'parliament-chart--simple'}>
                    <div className={'container--itemChart-title'}>
                        <h3>Απλή Αναλογική</h3>
                    </div>
                    <HighchartsReact highcharts={Highcharts} options={parliamentChart_Simple}/>
                </div> */}
        <div className={"parliament-chart--reinforced"}>
          <div className={"container--itemChart-title"}>
            <h3>Ενισχυμένη Αναλογική με Bonus</h3>
          </div>
          <HighchartsReact
            highcharts={Highcharts}
            options={parliamentChart_Reinforced}
          />
        </div>
      </div>
      <p className={"info--text"}>
        <sup>*</sup>
        {filter.value === 0 ? (
          <span>
            Η κατανομή εδρών προκύπτει από την τελευταία μέση τιμή όλων των
            εταιρειών
          </span>
        ) : (
          <span>
            Η κατανομή εδρών προκύπτει από την τελευταία μέση τιμή της{" "}
            {filter.label}
          </span>
        )}
      </p>
    </section>
  );
};

export default Parliament;
